export default __webpack_public_path__ + "static/media/ECWUser.cf4a3ff2.webp";